export default "__VITE_ASSET__$Aqcgtmu__"